import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type SetPrimaryOperation = paths['/executor_web/payment_ways/{type}/{id}/set_primary']['post'];

export type SetPaymentWayPrimaryPath = SetPrimaryOperation['parameters']['path'];
export type SetPaymentWayPrimaryResponse = SetPrimaryOperation['responses'][200]['content']['application/json'];

/** POST `/executor_web/payment_ways/{type}/{id}/set_primary` — сделать метод оплаты основным */
export function setPaymentWayPrimary(path: SetPaymentWayPrimaryPath, signal?: AbortSignal) {
	return axiosInstance.post<SetPaymentWayPrimaryResponse>(
		`payment_ways/${encodeURIComponent(path.type)}/${path.id}/set_primary`,
		undefined,
		{signal},
	);
}

type MarkDeleteOperation = paths['/executor_web/payment_ways/{type}/{id}/mark_delete']['post'];

export type MarkDeletePaymentWayPath = MarkDeleteOperation['parameters']['path'];
export type MarkDeletePaymentWayResponse = MarkDeleteOperation['responses'][200]['content']['application/json'];

/** POST `/executor_web/payment_ways/{type}/{id}/mark_delete` — удалить метод оплаты */
export function markDeletePaymentWay(path: MarkDeletePaymentWayPath, signal?: AbortSignal) {
	return axiosInstance.post<MarkDeletePaymentWayResponse>(
		`payment_ways/${encodeURIComponent(path.type)}/${path.id}/mark_delete`,
		undefined,
		{signal},
	);
}
